module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/link-to-2367d625d07fa445a6fe04d17c5682c1.svg";